export const AUTH_PERSONNEL_LOADED = 'AUTH_PERSONNEL_LOADED'

export const AUTH_PERSON_ASSSIGNED = 'AUTH_PERSON_ASSSIGNED'
export const AUTH_PERSON_SUBMITTED = 'AUTH_PERSON_SUBMITTED'

export const AUTH_PERSON_SUBMITTED_PENDING = 'AUTH_PERSON_SUBMITTED_PENDING'
export const AUTH_PERSON_SUBMITTED_FAILED = 'AUTH_PERSON_SUBMITTED_FAILED'
export const AUTH_PERSON_SUBMITTED_SUCCESS = 'AUTH_PERSON_SUBMITTED_SUCCESS'


// WEBPACK FOOTER //
// ./src/auth-personnel/constants.js